import { useFeatureFlagEnabled, useFeatureFlagPayload as usePostHogFeatureFlagPayload } from '@posthog/react';

export type FeatureFlagPayloadMap = {
  'video-cover-upload': { allowedCompanyIds: number[] };
  'floorplan-interactive-editor': { allowedCompanyIds: number[]; allCompanies?: boolean };
  'new-admission-form': { allowedCompanyIds: number[]; allCompanies?: boolean };
  'new-invitation-form': { allowedCompanyIds: number[]; allCompanies?: boolean };
  'event-secret-location': Record<string, never>;
  'extra-guests-for-bottle-services': Record<string, never>;
  'widget-config-enable-sign-in': Record<string, never>;
  'new-addon-form': { allowedCompanyIds: number[]; allCompanies?: boolean };
  'admission-image-gallery': Record<string, never>;
  'addon-image-gallery': Record<string, never>;
  'admission-include-drinks': Record<string, never>;
  'addon-terms-and-conditions-link': Record<string, never>;
};

export type FeatureFlag = keyof FeatureFlagPayloadMap;

export const useFeatureFlag = (key: FeatureFlag): boolean => useFeatureFlagEnabled(key) ?? false;

export const useFeatureFlagPayload = <K extends FeatureFlag>(key: K): FeatureFlagPayloadMap[K] | undefined =>
  usePostHogFeatureFlagPayload(key) as FeatureFlagPayloadMap[K] | undefined;
